import type React from "react";
import { Link } from "react-router-dom";
import { useDiaries } from "@/hooks/useDiaries";
import DiaryItem from "./components/DiaryItem";

const DiaryListPage: React.FC = () => {
	const { diaries, loading, error } = useDiaries();

	if (loading) {
		return (
			<div className="container mx-auto px-4 py-8">
				<p className="text-center text-gray-500">読み込み中...</p>
			</div>
		);
	}

	if (error) {
		return (
			<div className="container mx-auto px-4 py-8">
				<p className="text-center text-red-500">
					エラーが発生しました: {error.message}
				</p>
			</div>
		);
	}

	return (
		<div className="container mx-auto px-4 py-8">
			<div className="flex justify-between items-center mb-6">
				<h1 className="text-3xl font-bold">日記一覧</h1>
				<Link
					to="/webapp/diary/new"
					className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
				>
					新しい日記を書く
				</Link>
			</div>

			{diaries.length === 0 ? (
				<div className="text-center py-8">
					<p className="text-gray-500 mb-4">まだ日記が書かれていません</p>
					<p className="text-sm text-gray-400">
						「新しい日記を書く」ボタンから日記を作成してください
					</p>
				</div>
			) : (
				<div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
					{diaries
						.sort(
							(a, b) =>
								new Date(b.createdAt).getTime() -
								new Date(a.createdAt).getTime(),
						)
						.map((diary) => (
							<DiaryItem key={diary.id} diary={diary} />
						))}
				</div>
			)}
		</div>
	);
};

export default DiaryListPage;
